module.exports = __webpack_public_path__ + "img/header.531d88b5.jpg";